<template>
  <div class="detai_dialog">
    <div class="detail_head">
      <span class="label" style="text-align: left">{{
        $t("terminal.group")
      }}</span>
      <span class="name">
        <span>{{ $t("terminal.onlineNum") }}</span>
        <span>{{ $t("terminal.offlineNum") }}</span>
        <span>{{ $t("terminal.totalNum") }}</span>
      </span>
    </div>
    <div class="sc-body" v-loading="loading">
      <el-tree :data="online_total" :props="defaultProps" default-expand-all>
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="nodelabel">{{ node.label }}</span>
          <span class="custom-tree-node-item">
            <span style="color: green">
              {{ data.online }}
            </span>
            <span style="color: red">
              {{ data.count - data.online }}
            </span>
            <span>
              {{ data.count }}
            </span>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnlineDetail",
  // props:{
  // 	online_total:{
  // 		type:Array
  // 	}
  // },
  data() {
    return {
      // count_dev: 0,
      // expandedKeys: [],
      online_total: [],
      detailDialog: false,
      loading: false,
      defaultProps: {
        children: "child",
        label: "group_name",
      },
      groupIds: sessionStorage.getItem('group_ids'),
    }
  },

  methods: {
    async getDeviceLine() {
      this.loading = true;
      await this.$http.post("/admin/device/deviceCount", {
        group_ids: this.groupIds
      }, (data) => {
        this.stateStatistics(data);
        this.online_total = data;
      });
      this.loading = false;
    },

    stateStatistics(data) {
      let online = 0;
      let count = 0;
      for (let i = 0; i < data.length; i++) {
        let { child = [] } = data[i];
        if (child.length > 0) {
          const state = this.stateStatistics(child);
          data[i].online += state.online;
          data[i].count += state.count;
        }
        online += data[i].online;
        count += data[i].count;
      }
      return { online, count };
    }
    // getDeviceDetail(data) {
    //   data.forEach((ele) => {
    //     this.setName(ele.child);
    //     this.getCount(this.expandedKeys);
    //     ele.count += this.count_dev;
    //     this.count_dev = 0;
    //     this.expandedKeys = [];
    //   })
    //   data.forEach((ele) => {
    //     this.setOnline(ele.child);
    //     this.getCount(this.expandedKeys);
    //     ele.online += this.count_dev;
    //     this.count_dev = 0;
    //     this.expandedKeys = [];
    //   })

    // },
    // setName(datas) { //获取离线设备
    //   for (var i in datas) {
    //     this.expandedKeys.push(datas[i].count)
    //     if (datas[i].child.length != 0) {
    //       this.setName(datas[i].child);
    //     }
    //   }
    // },
    // setOnline(datas) {
    //   for (var i in datas) {
    //     this.expandedKeys.push(datas[i].online)
    //     if (datas[i].child.length != 0) {
    //       this.setOnline(datas[i].child);
    //     }
    //   }
    // },
    // getCount(val) {
    //   let cou = 0;
    //   for (let i = 0; i < val.length; i++) {
    //     cou += val[i];
    //   }
    //   this.count_dev = cou;
    // },
    // setOfflineNumber(data) {
    //   data.forEach((ele) => {
    //     let offline = ele.count - ele.online;
    //     this.$set(ele, 'offline', offline);
    //     if (ele.child.length != 0) {
    //       this.setOfflineNumber(ele.child);
    //     }
    //   })
    // },
    // async getDeviceTotal() {
    //   this.loading = true;
    //   await this.$http.post("/admin/device/deviceCount", {}, (data) => {
    //     console.log(data);
    //     for (let i = 0; i < data.length; i++) {
    //       if (data[i].group_id == this.$cookies.get('group_id')) {
    //         this.online_total = [data[i]];
    //       }
    //     }
    //   });
    //   for (let i in this.online_total) {
    //     this.getDeviceDetail(this.online_total);
    //     if (this.online_total[i].child.length != 0) {
    //       this.getDeviceDetail(this.online_total[i].child)
    //     }
    //   }
    //   //计算完在线设备后计算离线设备
    //   for (let i in this.online_total) {
    //     this.setOfflineNumber(this.online_total);
    //     if (this.online_total[i].child.length != 0) {
    //       this.setOfflineNumber(this.online_total[i].child)
    //     }
    //   }

    //   this.$forceUpdate();
    //   this.$nextTick(() => {
    //     this.detailDialog = true;
    //   })
    //   this.loading = false;
    //   console.log('最终数据...', this.online_total);
    // },
  },
  created() {
    // this.getDeviceTotal();
    this.getDeviceLine();
  }
}
</script>

<style lang="scss" scoped>
.detai_dialog {
  position: relative;
  height: 30vw;

  //overflow-y: auto;
  span {
    line-height: 16px;
    font-size: 16px;
  }

  /deep/ .el-tree-node__content {
    width: 615px;
    border-bottom: 1px dashed #d9d9d9;
    height: 35px;
    box-sizing: border-box;
    //padding-left: 0;
  }

  /deep/ .el-tree {
    margin-top: 20px;
  }

  .sc-body {
    height: calc(100% - 15px);
    overflow-y: auto;
  }

  .detail_head {
    width: calc(100% - 43px);
    position: fixed;
    top: 70px;
    //left: -26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    height: 20px;
    color: var(--theme-color-customized-1);
    font-size: 18px;
    z-index: 9999;
    background-color: white;

    //border-bottom: 2px solid var(--theme-color-customized-1);
    .label {
      flex: 1;
      padding-left: 50px;
    }

    .name {
      display: flex;
      align-items: center;
      width: 420px;

      span {
        display: block;
        width: 140px;
      }
    }
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    span {
      display: block;
    }

    .nodelabel {
      //flex: 1;
      //max-width: 75px;
      //max-width: calc(100% - 300px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      //max-width: 170px;
    }

    .custom-tree-node-item {
      width: 420px;
      min-width: 420px;
      //margin-right: 10px;
      //padding-right: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 0;

      span {
        width: 140px;
        text-align: center;
      }
    }
  }
}
</style>
